import {Link,useParams} from 'react-router-dom';
import {ArrowLeft,ArrowUpRight,BarChart3} from 'lucide-react';
import type {Analytics} from '../../lib/types';
import {useQuery} from '../../lib/useQuery';
import {Heading,QueryState} from '../../app/components';
import {AnalyticsControls,sourceNames,useAnalyticsState} from './analyticsState';
import {MetricsGrid} from './AnalyticsPage';

export function ArticleAnalyticsPage(){
 const {id}=useParams(),state=useAnalyticsState();
 const q=useQuery<Analytics>('getAnalytics',{...state.query,filter:{},itemIds:[id],groupBy:'item'},state.valid&&!!id);
 const article=q.data?.groups.find(group=>group.itemId===id||group.key===id);
 const sources=[...new Set(article?.metrics.map(metric=>metric.source)||[])];
 return <div className="insights-page article-report">
  <Link className="text-link article-report-back" to={state.link('/analytics')}><ArrowLeft size={15}/>Tilbage til Analyse</Link>
  <Heading eyebrow={'ARTIKELRAPPORT'+(article?.locale?' · '+article.locale.toUpperCase():'')} title={article?.title||'Artikelrapport'} description="Alle nøgletal for artiklen, fordelt på datakilde.">
   {article?.href?.startsWith('/knowledge/')&&<Link className="article-report-action" to={state.link(article.href)}>Åbn i Knowledge</Link>}
   {article?.publicUrl&&/^https?:\/\//.test(article.publicUrl)&&<a className="article-report-action" href={article.publicUrl} target="_blank" rel="noreferrer">Se artikel <ArrowUpRight size={15} aria-hidden="true"/></a>}
  </Heading>
  <AnalyticsControls state={state}/>
  {state.valid&&<QueryState {...q} variant="metrics">
   {article&&sources.length>0?<>
    <p className="article-report-note">0 er et målt nul. — betyder, at der ikke er en måling. Åbn datagrundlaget under et tal for at se dækning og eventuelle begrænsninger.</p>
    {sources.map(source=><section className="article-report-source" key={source} aria-label={sourceNames[source]||source}>
     <div className="insight-section-heading"><h2>{sourceNames[source]||source}</h2></div>
     <MetricsGrid metrics={article.metrics.filter(metric=>metric.source===source)} comparison={article.comparison} compare={state.comparison==='previous_period'} limit={Infinity}/>
    </section>)}
   </>:<div className="panel empty-state insight-empty"><BarChart3 size={28}/><h2>Ingen artikeldata i dette udvalg</h2><p>Vælg en anden periode eller datakilde. Rapporten viser kun publicerede artikler, du har adgang til.</p></div>}
  </QueryState>}
 </div>;
}
